// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8f19a7ca","160":"401edf3b","208":"7d95956f","293":"d561f0a3","453":"fa2a7b52","516":"b5335bd7","519":"d3973072","917":"2eba9452","946":"40044660"}[chunkId] + ".chunk.js";
};